// extracted by mini-css-extract-plugin
export default {"bodyMain":"style_bodyMain__73VmL","listItem":"style_listItem__377y9"};